// extracted by css-extract-rspack-plugin
export default {"payButtonWrapper":"raGEVc_r"};